import React, { useContext, useState } from 'react';

type ContextType = {
  ctx: CanvasRenderingContext2D | null;
  setCtx: (ctx: CanvasRenderingContext2D) => void;
  layer: any;
  setLayer: (layer: any) => void;
  paths: string[];
  setPaths: (paths: string[]) => void;

  scale: number;
  setScale: (scale: number) => void;
  cols: number;
  setCols: (cols: number) => void;
  rows: number;
  setRows: (rows: number) => void;

  hoveredHexPath: Path2D | null;
  setHoveredHexPath: (hoveredHexPath: Path2D | null) => void;
  isHexClickBlocked: boolean;
  setIsHexClickBlocked: (isHexClickBlocked: boolean) => void;
};
type Props = {
  children: React.ReactNode;
};

export const OverlayContextProvider = ({ children }: Props): JSX.Element => {
  const [ctx, setCtx] = useState<CanvasRenderingContext2D | null>(null);
  const [layer, setLayer] = useState<any>(null);
  const [paths, setPaths] = useState<string[]>([]);

  const [scale, setScale] = useState<number>(1);
  const [cols, setCols] = useState<number>(0);
  const [rows, setRows] = useState<number>(0);

  const [hoveredHexPath, setHoveredHexPath] = useState<Path2D | null>(null);
  const [isHexClickBlocked, setIsHexClickBlocked] = useState<boolean>(false);

  const value = {
    ctx,
    setCtx,
    scale,
    setScale,
    hoveredHexPath,
    setHoveredHexPath,
    isHexClickBlocked,
    setIsHexClickBlocked,
    paths,
    setPaths,
    layer,
    setLayer,
    cols,
    setCols,
    rows,
    setRows,
  };

  return (
    <OverlayContext.Provider value={value}>{children}</OverlayContext.Provider>
  );
};

export const OverlayContext = React.createContext({} as ContextType);
export const useOverlayContext = (): ContextType => useContext(OverlayContext);
